/* ============================================================================
   mollaoglou.js — cutting-edge etkileşim katmanı (v2)
   Yüklenir: layout/theme.liquid içinde </body> öncesi, defer.
   İlke: progressive enhancement. JS yoksa/başarısızsa her şey çalışır (linkler,
   okunur içerik). Tüm hareket prefers-reduced-motion + işaretçi türüne saygılı.
   Reveal/parallax = saf CSS (burada DEĞİL). JS yalnızca CSS'in yapamadığını yapar.
   ========================================================================== */
(function () {
  "use strict";
  var REDUCE = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var FINE = window.matchMedia && window.matchMedia("(pointer: fine)").matches;
  var ease = function (t) { return 1 - Math.pow(1 - t, 3); }; // easeOutCubic

  /* -- 1) Magnetik CTA ----------------------------------------------------- */
  function initMagnetic() {
    if (REDUCE || !FINE) return;
    document.querySelectorAll("[data-mo-magnetic]").forEach(function (el) {
      var strength = parseFloat(el.getAttribute("data-mo-magnetic")) || 0.3;
      var max = 14, r = null;
      el.addEventListener("pointerenter", function () { r = el.getBoundingClientRect(); });
      el.addEventListener("pointermove", function (e) {
        if (!r) r = el.getBoundingClientRect();   // cache: per-move reflow yok
        var x = (e.clientX - (r.left + r.width / 2)) * strength;
        var y = (e.clientY - (r.top + r.height / 2)) * strength;
        el.style.setProperty("--mo-mx", Math.max(-max, Math.min(max, x)).toFixed(1) + "px");
        el.style.setProperty("--mo-my", Math.max(-max, Math.min(max, y)).toFixed(1) + "px");
      });
      el.addEventListener("pointerleave", function () {
        r = null;
        el.style.setProperty("--mo-mx", "0px");
        el.style.setProperty("--mo-my", "0px");
      });
    });
  }

  /* -- 2) Count-up istatistik --------------------------------------------- */
  function fmt(n, dec) {
    try { return new Intl.NumberFormat("el-GR", { maximumFractionDigits: dec || 0 }).format(n); }
    catch (e) { return String(Math.round(n)); }
  }
  function countTo(el) {
    var target = parseFloat(el.getAttribute("data-mo-count"));
    if (isNaN(target)) return;
    var prefix = el.getAttribute("data-mo-prefix") || "";
    var suffix = el.getAttribute("data-mo-suffix") || "";
    var dur = parseInt(el.getAttribute("data-mo-dur"), 10) || 1400;
    if (REDUCE) { el.textContent = prefix + fmt(target) + suffix; return; }
    var start = null;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min(1, (ts - start) / dur);
      el.textContent = prefix + fmt(target * ease(p)) + suffix;
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = prefix + fmt(target) + suffix;
    }
    requestAnimationFrame(step);
  }
  function initCounters() {
    /* 2026-08-06 — «0 προϊόντα» hatasinin kaynagi buydu.
       Bu sayac animasyonu mo-why.liquid icin yazildi ve hedefi ozniteligin DEGERINDEN
       okuyor (countTo: parseFloat(el.getAttribute("data-mo-count"))).
       Ama mo-collection.liquid ayni adi DEGERSIZ bir kanca olarak kullaniyor:
       <span data-mo-count>1165</span> — deger oznitelikte degil, metinde.
       Eski secici bu ucunu de yakaliyordu: once metni "0" yapiyor (asagida), sonra
       parseFloat("") = NaN oldugu icin animasyon hic calismiyordu. Sonuc: sunucu 1165
       gonderiyor, musteri 24 urun dolu bir sayfada «0 προϊόντα» goruyordu.
       Cozum: yalniz degeri OLAN kancalari al. Koleksiyon sayaclarina dokunulmaz. */
    var els = document.querySelectorAll('[data-mo-count]:not([data-mo-count=""])');
    if (!els.length) return;
    // JS var → animasyon için 0'dan başlat (no-JS statik gerçek değeri korur, flash yok)
    if (!REDUCE) els.forEach(function (el) {
      el.textContent = (el.getAttribute("data-mo-prefix") || "") + "0" + (el.getAttribute("data-mo-suffix") || "");
    });
    if (!("IntersectionObserver" in window)) { els.forEach(countTo); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { countTo(en.target); io.unobserve(en.target); }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* -- 3) ΟΔΗΓΟΣ ΧΡΩΜΑΤΟΣ — 3 adımlı seçici → CTA URL (+ koşullu adım 3) --- */
  function initGuide() {
    var guide = document.querySelector("[data-mo-guide]");
    if (!guide) return;
    var cta = guide.querySelector("[data-mo-guide-cta]");
    var summary = guide.querySelector("[data-mo-guide-summary]");
    var base = (cta && cta.getAttribute("data-base")) || "/search";
    var step3 = guide.querySelector('[data-mo-step="03"]');
    function update() {
      // Ταράτσα/Μέταλλο seçilince φινίρισμα adımı anlamsız → gizle
      var s2 = guide.querySelector('input[name="g02"]:checked');
      if (step3) step3.style.display = (s2 && s2.getAttribute("data-skip-finish")) ? "none" : "";
      var picks = [], qparts = [];
      guide.querySelectorAll("[data-mo-step]").forEach(function (st) {
        if (st.style.display === "none") return;
        var sel = st.querySelector("input:checked");
        if (!sel) return;
        if (sel.getAttribute("data-label")) picks.push(sel.getAttribute("data-label"));
        if (sel.getAttribute("data-q")) qparts.push(sel.getAttribute("data-q"));
      });
      if (summary) summary.textContent = picks.length ? picks.join(" · ") : "—";
      if (cta) cta.setAttribute("href", qparts.length ? base + "?q=" + encodeURIComponent(qparts.join(" ")) + "&type=product" : base);
    }
    guide.addEventListener("change", function (e) {
      if (e.target && e.target.matches('input[type="radio"]')) update();
    });
    update();
  }

  /* -- 4) Litre hesaplayıcı (Πόσα λίτρα;) ---------------------------------- */
  function initCalc() {
    var box = document.querySelector("[data-mo-calc]");
    if (!box) return;
    var area = box.querySelector("[data-mo-calc-area]");
    var coats = box.querySelector("[data-mo-calc-coats]");
    var out = box.querySelector("[data-mo-calc-out]");
    var segBtns = box.querySelectorAll("[data-mo-calc-cov]");
    var cov = 11;
    function calc() {
      var a = parseFloat(area.value) || 0;
      var c = parseInt(coats.value, 10) || 0;
      if (a <= 0 || c <= 0) { out.textContent = "—"; return; }
      out.textContent = fmt((a * c) / cov, 1);
    }
    segBtns.forEach(function (b) {
      b.addEventListener("click", function () {
        segBtns.forEach(function (x) { x.setAttribute("aria-pressed", "false"); });
        b.setAttribute("aria-pressed", "true");
        cov = parseFloat(b.getAttribute("data-mo-calc-cov")) || 11;
        calc();
      });
    });
    if (area) area.addEventListener("input", calc);
    if (coats) coats.addEventListener("input", calc);
  }

  /* -- 5) Marquee: klonla + off-screen/pause kontrol ----------------------- */
  function initMarquee() {
    if (!REDUCE) {
      document.querySelectorAll("[data-mo-marquee]").forEach(function (m) {
        if (m.getAttribute("data-mo-cloned")) return;
        var row = m.querySelector(".mo-marquee__row");
        if (!row) return;
        var clone = row.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        clone.querySelectorAll("a").forEach(function (a) { a.tabIndex = -1; }); // çift Tab turu olmasın
        m.appendChild(clone);
        m.setAttribute("data-mo-cloned", "1");
      });
    }
    document.querySelectorAll("[data-mo-autoslide]").forEach(function (b) {
      // ekran dışında animasyonu durdur (perf/INP)
      if ("IntersectionObserver" in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (en) { b.classList.toggle("is-offscreen", !en.isIntersecting); });
        }, { threshold: 0 }).observe(b);
      }
      // görünür Παύση/Αναπαραγωγή düğmesi (WCAG 2.2.2 — touch dahil)
      var btn = b.querySelector("[data-mo-marquee-toggle]");
      if (btn) btn.addEventListener("click", function () {
        var paused = b.classList.toggle("is-paused");
        btn.setAttribute("aria-pressed", paused ? "true" : "false");
        btn.setAttribute("aria-label", paused ? "Αναπαραγωγή κύλισης" : "Παύση κύλισης");
      });
    });
  }

  /* -- 6) ΟΔΗΓΟΣ ΧΡΩΜΑΤΟΣ — 3 adımlı ÜRÜN bulucu (sonuç ürün tipi + link) --- */
  function initFinder() {
    var box = document.querySelector("[data-mo-finder-box]");
    if (!box) return;
    var loc = box.querySelector("#mf-loc"), surf = box.querySelector("#mf-surf"), fin = box.querySelector("#mf-fin");
    var out = box.querySelector("[data-mo-finder-out]"), cta = box.querySelector("[data-mo-finder-cta]");
    if (!loc || !surf || !fin) return;
    function txt(s) { return s.options[s.selectedIndex].text; }
    function compute() {
      var sv = surf.value, F = txt(fin), product, qq;
      if (sv === "ξυλου") { product = "Βερνίκι / χρώμα ξύλου (" + F + ")"; qq = "βερνίκι χρώμα ξύλου"; }
      else if (sv === "μεταλλου") { product = "Αντισκωριακό χρώμα μετάλλου"; qq = "αντισκωριακό χρώμα μετάλλου"; }
      else if (sv === "ταρατσα") { product = "Στεγανωτικό ταράτσας + αστάρι"; qq = "στεγανωτικό ταράτσας"; }
      else { var base = loc.value === "εξωτερικού" ? "Ακρυλικό" : "Πλαστικό";
             product = base + " " + F.toLowerCase() + " χρώμα " + loc.value; qq = base + " χρώμα " + loc.value + " " + F; }
      if (out) out.textContent = product;
      if (cta) cta.setAttribute("href", "/search?type=product&q=" + encodeURIComponent(qq));
    }
    [loc, surf, fin].forEach(function (s) { s.addEventListener("change", compute); });
    compute();
  }

  /* -- 7) Renk şeritleri: TIKLA + SÜRÜKLE (oto-marquee DEĞİL) --------------- */
  function initColorStrips() {
    document.querySelectorAll("[data-mo-strip]").forEach(function (strip) {
      var down = false, sx = 0, sl = 0, moved = false, pid = null;
      strip.addEventListener("pointerdown", function (e) {
        down = true; moved = false; sx = e.clientX; sl = strip.scrollLeft; pid = e.pointerId;
        try { strip.setPointerCapture(pid); } catch (_) {}
      });
      strip.addEventListener("pointermove", function (e) {
        if (!down) return;
        var dx = e.clientX - sx;
        if (Math.abs(dx) > 8) { moved = true; strip.classList.add("is-dragging"); }   // eşik: tık-vs-sürükle
        if (moved) strip.scrollLeft = sl - dx;
      });
      function end() {
        if (pid != null) { try { strip.releasePointerCapture(pid); } catch (_) {} pid = null; }
        down = false;
        // is-dragging'i click event'inden SONRA kaldır (yanlışlıkla linke gitmeyi önler)
        setTimeout(function () { strip.classList.remove("is-dragging"); }, 0);
      }
      strip.addEventListener("pointerup", end);
      strip.addEventListener("pointercancel", end);
      strip.addEventListener("click", function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); }   // sürüklerken navigasyon iptal
      }, true);

      // prev/next kontrolleri (WCAG 2.5.7 — sürüklemenin tek-tık alternatifi)
      var wrap = strip.closest(".mo-strip-wrap") || strip.parentNode;
      var prev = wrap.querySelector("[data-mo-strip-prev]");
      var next = wrap.querySelector("[data-mo-strip-next]");
      var beh = REDUCE ? "auto" : "smooth";
      function step() { return Math.max(180, Math.round(strip.clientWidth * 0.8)); }
      if (prev) prev.addEventListener("click", function () { strip.scrollBy({ left: -step(), behavior: beh }); });
      if (next) next.addEventListener("click", function () { strip.scrollBy({ left: step(), behavior: beh }); });
      function upd() {
        var max = strip.scrollWidth - strip.clientWidth - 2;
        if (prev) prev.hidden = strip.scrollLeft <= 1;
        if (next) next.hidden = strip.scrollLeft >= max;
      }
      strip.addEventListener("scroll", upd, { passive: true });
      if (window.ResizeObserver) { new ResizeObserver(upd).observe(strip); }
      else window.addEventListener("resize", upd);
      upd();
    });
  }

  /* -- 8) ΠΑΡΕ ΤΗ ΣΚΗΝΗ — hotspot pin → kart (masaüstü popover / mobil sheet) */
  function initScenes() {
    var mqMobile = window.matchMedia("(max-width: 640px)");
    document.querySelectorAll("[data-mo-scene]").forEach(function (stage) {
      var openPin = null, openCard = null, backdrop = null;
      function detach() {
        document.removeEventListener("keydown", onKey, true);
        document.removeEventListener("pointerdown", onDoc, true);
      }
      function closeAll(returnFocus) {
        var p = openPin;
        if (openCard) { openCard.hidden = true; openCard.classList.remove("is-sheet"); openCard.style.marginLeft = ""; }
        if (openPin) openPin.setAttribute("aria-expanded", "false");
        if (backdrop && backdrop.parentNode) backdrop.parentNode.removeChild(backdrop);
        backdrop = null; openCard = null; openPin = null;
        detach();
        if (returnFocus && p) p.focus();
      }
      function onKey(e) { if (e.key === "Escape") { e.stopPropagation(); closeAll(true); } }
      function onDoc(e) {
        if (openCard && !openCard.contains(e.target) && openPin && !openPin.contains(e.target)) closeAll(false);
      }
      function open(pin, card) {
        closeAll(false);
        openPin = pin; openCard = card;
        card.hidden = false;
        pin.setAttribute("aria-expanded", "true");
        if (mqMobile.matches) {
          card.classList.add("is-sheet");
          backdrop = document.createElement("div");
          backdrop.className = "mo-scene__backdrop";
          stage.appendChild(backdrop);
          backdrop.addEventListener("click", function () { closeAll(true); });
        } else {
          card.classList.remove("is-sheet");
          card.style.left = pin.style.left;
          card.style.top = pin.style.top;
          card.style.marginLeft = "";
          var sr = stage.getBoundingClientRect(), cr = card.getBoundingClientRect();   // yatay taşmayı düzelt
          var overR = cr.right - sr.right, overL = sr.left - cr.left;
          if (overR > 0) card.style.marginLeft = (-(overR + 10)) + "px";
          else if (overL > 0) card.style.marginLeft = (overL + 10) + "px";
        }
        var cb = card.querySelector("[data-mo-card-close]");
        if (cb) cb.focus();
        setTimeout(function () {
          document.addEventListener("keydown", onKey, true);
          document.addEventListener("pointerdown", onDoc, true);
        }, 0);
      }
      stage.querySelectorAll("[data-mo-pin]").forEach(function (pin) {
        var card = document.getElementById(pin.getAttribute("aria-controls"));
        if (!card) return;
        pin.addEventListener("click", function (e) {
          e.stopPropagation();
          if (openPin === pin) { closeAll(true); return; }
          open(pin, card);
        });
        var cb = card.querySelector("[data-mo-card-close]");
        if (cb) cb.addEventListener("click", function (e) { e.stopPropagation(); closeAll(true); });
      });
    });
  }

  function init() {
    try { initMagnetic(); } catch (e) {}
    try { initCounters(); } catch (e) {}
    try { initFinder(); } catch (e) {}
    try { initMarquee(); } catch (e) {}
    try { initColorStrips(); } catch (e) {}
    try { initScenes(); } catch (e) {}
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
